import { Action, createReducer, on } from '@ngrx/store';
import {
  requestsTypeInitialState,
  RequestsTypeState,
} from './requests-type.state';
import { RequestsTypeActions } from './requests-type.actions';

const _requestsTypeReducer = createReducer(
  requestsTypeInitialState(),

  /**
   * Reducers For Get All Requests Type
   */

  on(RequestsTypeActions.getAllRequestsType, (state) => {
    return {
      ...state,
      allRequestsType: {
        loading: true,
      },
    };
  }),
  on(
    RequestsTypeActions.getAllRequestsTypeSuccess,
    (state, { requestsType }) => {
      return {
        ...state,
        allRequestsType: {
          loading: false,
          data: requestsType.data,
        },
      };
    }
  ),
  on(RequestsTypeActions.getAllRequestsTypeFailure, (state, { failure }) => {
    return {
      ...state,
      allRequestsType: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Create Request Type
   */

  on(RequestsTypeActions.createRequestType, (state) => {
    return {
      ...state,
      createRequestType: {
        loading: true,
      },
    };
  }),
  on(RequestsTypeActions.createRequestTypeSuccess, (state, { response }) => {
    return {
      ...state,
      createRequestType: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(RequestsTypeActions.createRequestTypeFailure, (state, { failure }) => {
    return {
      ...state,
      createRequestType: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Update Request Type
   */

  on(RequestsTypeActions.updateRequestType, (state) => {
    return {
      ...state,
      updateRequestType: {
        loading: true,
      },
    };
  }),
  on(RequestsTypeActions.updateRequestTypeSuccess, (state, { response }) => {
    return {
      ...state,
      updateRequestType: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(RequestsTypeActions.updateRequestTypeFailure, (state, { failure }) => {
    return {
      ...state,
      updateRequestType: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Update Request Type
   */

  on(RequestsTypeActions.getRequestActionsByCompany, (state) => {
    return {
      ...state,
      requestActionsByCompany: {
        loading: true,
      },
    };
  }),
  on(
    RequestsTypeActions.getRequestActionsByCompanySuccess,
    (state, { response }) => {
      return {
        ...state,
        requestActionsByCompany: {
          loading: false,
          data: response.data,
        },
      };
    }
  ),
  on(
    RequestsTypeActions.getRequestActionsByCompanyFailure,
    (state, { failure }) => {
      return {
        ...state,
        requestActionsByCompany: {
          loading: false,
          failure: failure,
        },
      };
    }
  ),
  /**
   * Reducers For Update Request Type
   */

  on(RequestsTypeActions.changeRequestActionType, (state) => {
    return {
      ...state,
      changeRequestActionType: {
        loading: true,
      },
    };
  }),
  on(
    RequestsTypeActions.changeRequestActionTypeSuccess,
    (state, { response }) => {
      return {
        ...state,
        changeRequestActionType: {
          loading: false,
          data: response.data,
        },
      };
    }
  ),
  on(
    RequestsTypeActions.changeRequestActionTypeFailure,
    (state, { failure }) => {
      return {
        ...state,
        changeRequestActionType: {
          loading: false,
          failure: failure,
        },
      };
    }
  )
);

export function requestsTypeReducer(
  state: RequestsTypeState | undefined,
  action: Action
) {
  return _requestsTypeReducer(state, action);
}
